import { useState } from "react";
import { useLayerList } from "../../hooks";
import { LAYER_STATES } from "../../redux/reducers/mapViewReducer";
import LayerItem from "./LayerItem";

const LAYER_LIST_STATES = Object.freeze({
  ...LAYER_STATES,
  PARTIALLY_LOADED: "partiallyLoaded",
});

const LayerListWidget = ({ view, t, config, isSidebar }) => {
  const [showLayerList, setShowLayerList] = useState(false);
  const [layers, setLayers] = useLayerList();

  if (!view) return;

  return (
    <>
      {layers.map((item) => (
        <LayerItem
          key={item.title}
          view={view}
          config={config}
          title={item.title}
          groupedLayers={item.groupedLayers}
          information={item.information}
          getLayerTitle={item.getLayerTitle}
          getLayerInformation={item.getLayerInformation}
          t={t}
          layerListVisible={showLayerList}
          isSidebar={isSidebar}
        />
      ))}
    </>
  );
};

export default LayerListWidget;
